export const clickOutside = {
    beforeMount: (el: any, binding: any) => {
        document.addEventListener('click', (event: Event) => {
            if (!(el === event.target || el.contains(event.target))) {
                binding.value(event);
            }
        });
    },
    unmounted: (el: any) => {
        document.removeEventListener('click', el.clickOutsideEvent);
    },
};

export default clickOutside;
